import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']

  toggle () {
    this.menuTarget.classList.toggle('hidden')
  }

  hide (event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add('hidden')
    }
  }

  connect () {
    this._hideHandler = this.hide.bind(this)
    document.addEventListener('click', this._hideHandler)
  }

  disconnect () {
    document.removeEventListener('click', this._hideHandler)
  }
}
